import { z } from 'zod';
/**
 * Лёгкий справочник пользователей для автокомплитов (`GET /api/users`).
 *
 * В отличие от `GET /api/admin/users` (только platform_admin, полный
 * профиль) — этот эндпоинт доступен любому аутентифицированному
 * пользователю и отдаёт минимальный публичный slice. Спека позволяет
 * базовой роли `user` «видеть всех пользователей в автокомплитах»
 * (REQUIREMENTS.md §2.2). Используется пикерами владельца/редакторов
 * справочника и аналогичными местами.
 */
export const DirectoryUserSchema = z.object({
    id: z.string().uuid(),
    login: z.string(),
    displayName: z.string(),
    isPlatformAdmin: z.boolean(),
});
export const DirectoryUsersResponseSchema = z.object({
    users: z.array(DirectoryUserSchema),
});
